/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlDirectoryUserGroupCount } from './ControlDirectoryUserGroupCount';
import {
    ControlDirectoryUserGroupCountFromJSON,
    ControlDirectoryUserGroupCountFromJSONTyped,
    ControlDirectoryUserGroupCountToJSON,
} from './ControlDirectoryUserGroupCount';
import type { ControlDirectoryUserIntegrationCount } from './ControlDirectoryUserIntegrationCount';
import {
    ControlDirectoryUserIntegrationCountFromJSON,
    ControlDirectoryUserIntegrationCountFromJSONTyped,
    ControlDirectoryUserIntegrationCountToJSON,
} from './ControlDirectoryUserIntegrationCount';
import type { ControlDirectoryUserTypeCount } from './ControlDirectoryUserTypeCount';
import {
    ControlDirectoryUserTypeCountFromJSON,
    ControlDirectoryUserTypeCountFromJSONTyped,
    ControlDirectoryUserTypeCountToJSON,
} from './ControlDirectoryUserTypeCount';

/**
 * 
 * @export
 * @interface ControlDirectoryUserStats
 */
export interface ControlDirectoryUserStats {
    /**
     * 
     * @type {number}
     * @memberof ControlDirectoryUserStats
     */
    containedCount: number;
    /**
     * 
     * @type {number}
     * @memberof ControlDirectoryUserStats
     */
    disabledCount: number;
    /**
     * 
     * @type {number}
     * @memberof ControlDirectoryUserStats
     */
    enabledCount: number;
    /**
     * 
     * @type {Array<ControlDirectoryUserIntegrationCount>}
     * @memberof ControlDirectoryUserStats
     */
    integrations: Array<ControlDirectoryUserIntegrationCount>;
    /**
     * 
     * @type {number}
     * @memberof ControlDirectoryUserStats
     */
    totalCount: number;
    /**
     * 
     * @type {Array<ControlDirectoryUserGroupCount>}
     * @memberof ControlDirectoryUserStats
     */
    userGroups: Array<ControlDirectoryUserGroupCount>;
    /**
     * 
     * @type {Array<ControlDirectoryUserTypeCount>}
     * @memberof ControlDirectoryUserStats
     */
    userTypes: Array<ControlDirectoryUserTypeCount>;
}

/**
 * Check if a given object implements the ControlDirectoryUserStats interface.
 */
export function instanceOfControlDirectoryUserStats(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "containedCount" in value;
    isInstance = isInstance && "disabledCount" in value;
    isInstance = isInstance && "enabledCount" in value;
    isInstance = isInstance && "integrations" in value;
    isInstance = isInstance && "totalCount" in value;
    isInstance = isInstance && "userGroups" in value;
    isInstance = isInstance && "userTypes" in value;

    return isInstance;
}

export function ControlDirectoryUserStatsFromJSON(json: any): ControlDirectoryUserStats {
    return ControlDirectoryUserStatsFromJSONTyped(json, false);
}

export function ControlDirectoryUserStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlDirectoryUserStats {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'containedCount': json['containedCount'],
        'disabledCount': json['disabledCount'],
        'enabledCount': json['enabledCount'],
        'integrations': ((json['integrations'] as Array<any>).map(ControlDirectoryUserIntegrationCountFromJSON)),
        'totalCount': json['totalCount'],
        'userGroups': ((json['userGroups'] as Array<any>).map(ControlDirectoryUserGroupCountFromJSON)),
        'userTypes': ((json['userTypes'] as Array<any>).map(ControlDirectoryUserTypeCountFromJSON)),
    };
}

export function ControlDirectoryUserStatsToJSON(value?: ControlDirectoryUserStats | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'containedCount': value.containedCount,
        'disabledCount': value.disabledCount,
        'enabledCount': value.enabledCount,
        'integrations': ((value.integrations as Array<any>).map(ControlDirectoryUserIntegrationCountToJSON)),
        'totalCount': value.totalCount,
        'userGroups': ((value.userGroups as Array<any>).map(ControlDirectoryUserGroupCountToJSON)),
        'userTypes': ((value.userTypes as Array<any>).map(ControlDirectoryUserTypeCountToJSON)),
    };
}

